import { useEffect, useRef, useState } from "react";
import "./HeroBanner.scss";

const images = [
    "/images/odontology/scroll-1.jpg",
    "/images/odontology/scroll-2.jpg",
    "/images/odontology/scroll-3.jpg",
    "/images/odontology/scroll-4.jpg",
    "/images/odontology/scroll-5.jpg",
    "/images/odontology/scroll-6.jpg",
    "/images/odontology/scroll-7.jpg",
];

const IMAGES_GAP = 20; // px
const IMAGE_WIDTH = 464; // px
const SCROLL_SPEED = 0.5; // px per frame

const HeroBanner = () => {
    const [visibleImages, setVisibleImages] = useState(images);
    const containerRef = useRef(null);
    const trackRef = useRef(null);
    const offset = useRef(0);

    useEffect(() => {
        let animationFrameId;
        let imageWidth = containerRef.current.querySelector("img")?.offsetWidth || IMAGE_WIDTH;

        const animate = () => {
            offset.current -= SCROLL_SPEED;

            const track = trackRef.current;
            if (track) {
                track.style.transform = `translateX(${offset.current}px)`;

                if (Math.abs(offset.current) >= imageWidth + IMAGES_GAP) {
                    setVisibleImages((prev) => {
                        const [first, ...rest] = prev;
                        return [...rest, first];
                    });

                    setTimeout(() => {
                        offset.current += imageWidth + IMAGES_GAP;
                        track.style.transform = `translateX(${offset.current}px)`;
                    }, 0);
                }
            }

            animationFrameId = requestAnimationFrame(animate);
        };

        animationFrameId = requestAnimationFrame(animate);

        return () => cancelAnimationFrame(animationFrameId);
    }, []);

    return (
        <div className="hero-banner">
            <div className="text--container__wrapper">
                <div className="text--container">
                    <h2>BUILDING CODE FOR THE WORLD</h2>
                    <h1>
                        <span className="highlighted-text">BEYOND</span> THE
                        SCREEN
                    </h1>
                    <p>
                        More than just code, I deliver intuitive user
                        experiences and
                        real business value -- from concept to launch
                    </p>
                </div>
            </div>
            <div className="carousel" ref={containerRef}>
                <div
                    className="track"
                    style={{ "--gap": `${IMAGES_GAP}px` }}
                    ref={trackRef}
                >
                    {visibleImages.map((src, idx) => (
                        <img
                            key={idx}
                            src={src}
                            style={{
                                width: `${IMAGE_WIDTH}px`,
                                height: "auto",
                                flexShrink: 0,
                            }}
                            alt=""
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default HeroBanner;
